import { render } from "./BaseSpinner.vue?vue&type=template&id=3e2a1b74&scoped=true&ts=true"
import script from "./BaseSpinner.vue?vue&type=script&lang=ts"
export * from "./BaseSpinner.vue?vue&type=script&lang=ts"

import "./BaseSpinner.vue?vue&type=style&index=0&id=3e2a1b74&scoped=true&lang=scss"

import exportComponent from "/Users/aleksandrvasilevic/Documents/Dev/WEB/Pets/phone-book/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e2a1b74"]])

export default __exports__